import React, {useEffect, useRef, useState} from "react";
import {Button, Input, ListGroup, ListGroupItem} from "reactstrap";
import AddCustomer from "../../Customers/AddCustomer/AddCustomer";

/** Étape 1 : retrouver le client (nom, téléphone, e-mail, numéro de série…) ou le créer. */
export default function EtapeClient({api, client, onChoisir}) {
    const [recherche, setRecherche] = useState("");
    const [resultats, setResultats] = useState([]);
    const [chargement, setChargement] = useState(false);
    const [cherche, setCherche] = useState("");
    const [creation, setCreation] = useState(false);
    const champ = useRef(null);

    useEffect(() => {
        if (!client && champ.current) {
            champ.current.focus();
        }
    }, [client, creation]);

    useEffect(() => {
        const texte = recherche.trim();
        if (texte.length < 2) {
            setResultats([]);
            return undefined;
        }
        let annule = false;
        const minuteur = setTimeout(async () => {
            setChargement(true);
            try {
                const trouves = await api.chercherClients(texte);
                if (!annule) {
                    setResultats(trouves);
                    setCherche(texte);
                }
            } catch (e) {
                if (!annule) {
                    setResultats([]);
                    setCherche(texte);
                }
            }
            if (!annule) {
                setChargement(false);
            }
        }, 300);
        return () => {
            annule = true;
            clearTimeout(minuteur);
        };
    }, [recherche, api]);

    if (client) {
        const machines = client.appareils?.length ?? 0;
        return (
            <div className="assistant-pec-choix">
                <div>
                    <div className="h3 mb-1">{client.fullname || [client.prenom, client.nom].filter(Boolean).join(" ")}</div>
                    <div className="text-muted">
                        {[client.profile?.telephone_portable, client.profile?.telephone_fixe, client.email]
                            .filter(Boolean).join(" · ") || "Pas de coordonnées"}
                    </div>
                    <div className="text-muted small">
                        Client n° {client.id}
                        {machines > 0 && ` · ${machines} appareil${machines > 1 ? "s" : ""} déjà connu${machines > 1 ? "s" : ""}`}
                    </div>
                </div>
                <Button outline color="primary" onClick={() => onChoisir(null)}>Changer de client</Button>
            </div>
        );
    }

    if (creation) {
        return (
            <div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="mb-0">Nouveau client</h3>
                    <Button outline color="primary" onClick={() => setCreation(false)}>Revenir à la recherche</Button>
                </div>
                <AddCustomer card={false} onCallback={(nouveau) => nouveau && onChoisir(nouveau)}/>
            </div>
        );
    }

    return (
        <div>
            <h3>Qui dépose l'appareil ?</h3>
            <Input
                innerRef={champ}
                bsSize="lg"
                placeholder="Nom, prénom, téléphone, e-mail ou numéro de série d'un appareil déjà venu"
                value={recherche}
                onChange={e => setRecherche(e.target.value)}
                onKeyDown={e => {
                    if (e.key === "Enter" && resultats.length > 0) {
                        onChoisir(resultats[0]);
                    }
                }}
            />
            {chargement && <div className="text-muted small mt-2">Recherche…</div>}
            {resultats.length > 0 && (
                <ListGroup className="mt-2">
                    {resultats.map(u => (
                        <ListGroupItem key={u.id} tag="button" action onClick={() => onChoisir(u)}>
                            <strong>{u.fullname || [u.prenom, u.nom].filter(Boolean).join(" ")}</strong>
                            <span className="text-muted ml-2">
                                {[u.profile?.telephone_portable, u.email, u.profile?.ville].filter(Boolean).join(" · ")}
                            </span>
                            <span className="float-right text-muted small">n° {u.id}</span>
                        </ListGroupItem>
                    ))}
                </ListGroup>
            )}
            {!chargement && cherche === recherche.trim() && cherche.length >= 2 && resultats.length === 0 && (
                <div className="text-muted mt-2">Aucun client ne correspond.</div>
            )}
            <div className="mt-4">
                <Button color="success" size="lg" onClick={() => setCreation(true)}>
                    <i className="fa fa-user-plus mr-2"/>Nouveau client
                </Button>
            </div>
        </div>
    );
}
